module.exports = __webpack_public_path__ + "img/amulogo.f8749226.png";